import useFetchInstitutionAggregates from 'api/InstitutionResource/useFetchInstitutionAggregates';
import { FiBookOpen, FiUsers, FiUserCheck, FiShield } from 'react-icons/fi';
import { MetricCard, ReportPanel } from 'components/PortalDashboard';

export default function Aggregates() {
    const result = useFetchInstitutionAggregates();
    const data = result.data?.data;
    return <ReportPanel skeleton={{ variant: 'metrics', labels: ['Books purchased', 'Total users', 'Students', 'Educators', 'Admins'] }} title="Community highlights" description="Your institution's library and learning community." result={result}>
        <div className="portal-metrics portal-catalogue-metrics">
            <MetricCard label="Books purchased" value={data?.numberOfPurchasedBooks} icon={<FiBookOpen />} />
            <MetricCard label="Total users" value={data?.allUsers} icon={<FiUsers />} />
            <MetricCard label="Students" value={data?.numberOfStudents} icon={<FiUsers />} />
            <MetricCard label="Educators" value={data?.numberOfEducators} icon={<FiUserCheck />} />
            <MetricCard label="Admins" value={data?.numberOfAdmins} icon={<FiShield />} />
        </div>
    </ReportPanel>;
}
